import '@material-ui/icons'

export default function initMaterialUI(): string {
  return 'done'
}
